import React from "react";
import styled from "styled-components";
//
import Iframe from "react-iframe";
import { RichText } from "components/prismic";

export default ({ item_description, id, item_title, link, ...rest }) => (
  <Wrap key={id} id={id}>
    <Title>{item_title}</Title>
    <Text>
      <RichText {...item_description} />
    </Text>
    {link.url && (
      <Calendar>
        <Iframe url={link.url} width="100%" height="100%" frameBorder="0" />
      </Calendar>
    )}
    {/* <pre>
      <code>{JSON.stringify(rest, null, 2)}</code>
    </pre> */}
  </Wrap>
);
//
const Wrap = styled.div`
  padding-bottom: 5rem;
  padding-left: 0.25rem;

  :last-child {
    min-height: 80vh;
  }
`;
const Title = styled.h3`
  &:before {
    background-color: currentColor;
    content: "";
    display: block;
    height: 3px;
    margin: 0.5rem 0;
    width: 2rem;
  }
`;
const Text = styled.div`
  a {
    max-width: 300px;
  }

  h4 {
    border-top: solid 2px;
    margin: 3rem 0 0;
    max-width: 100%;
    padding: 1rem 0 0;
    font-size: 1.3em;
  }

  h5 {
    margin: 0.2rem 0;
  }

  img {
    max-height: 50vh;
  }

  li {
    line-height: 1.5;
    padding: 0.3rem 0;
  }
`;
const Calendar = styled.div`
  border: 1px solid #d9dce4;
  display: inline-block;
  padding: 0;
  margin: 0;
  width: 100%;
  height: 75vh;
  height: calc(75vh - 65px);
`;
